import { NgModule } from '@angular/core';
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { ClinicalAssessmentComponent } from './clinical-assessment/clinical-assessment.component';
import { AssessmentNotesComponent } from './assesments-notes-component/assessment-notes.component';
import { ClinicalAssessmentVoteComponent } from './clinical-assessment/clinical-assessment-vote/clinical-assessment-vote.component';
import { VizientAssessmentComponent } from './vizient-assessment/vizient-assessment.component';
import { VizientAssessmentVoteComponent } from './vizient-assessment/vizient-assessment-vote/vizient-assessment-vote.component';

/**
 * This component is now in its own module because it is getting reused in several grids but GridClinicalAssessmentWrapper
 * is what we will be using directly in the grid.
 *
 * Putting this in LayoutModule does not work because that will create a cyclical dependency with the Layout and Util module.
 */
@NgModule({
  declarations: [
    AssessmentNotesComponent,
    ClinicalAssessmentComponent,
    ClinicalAssessmentVoteComponent,
    VizientAssessmentComponent,
    VizientAssessmentVoteComponent,
  ],
  imports: [
    CommonModule,
    NgbPopoverModule,
    NgbNavModule,
    NgbModalModule,
    NgbDropdownModule,
    FormsModule,
  ],
  exports: [
    AssessmentNotesComponent,
    ClinicalAssessmentComponent,
    ClinicalAssessmentVoteComponent,
    VizientAssessmentComponent,
    VizientAssessmentVoteComponent,
  ],
  providers: [DatePipe],
})
export class CrossReferenceAssessmentsModule {}
